/* ข้อมูลลูกค้า (เมนู Support) */
import React, { useState } from "react";
import { Button, Col, Form, Input, Row, Select, Tooltip, Typography } from "antd";
import { KeyOutlined } from "@ant-design/icons";
import CrudPage from "../../../components/ak/CrudPage";
import StatusTag from "../../../components/ak/StatusTag";
import { CustomerService } from "../../../service/Ak.service";
import { PROVINCE_OPTIONS } from "../../../utils/util";
import PortalLoginModal from "./PortalLoginModal";

export const SOURCE_OPTIONS = ["Facebook", "Line OA", "เว็บไซต์", "หน้าโชว์รูม", "งานแสดงบ้าน", "ลูกค้าแนะนำ", "อื่น ๆ"].map((v) => ({ value: v, label: v }));

export const CustomerFormFields = () => (
  <Row gutter={12}>
    <Col xs={24} md={6}>
      <Form.Item name="prename" label="คำนำหน้า">
        <Select allowClear options={["คุณ", "นาย", "นาง", "นางสาว", "บริษัท"].map((v) => ({ value: v, label: v }))} />
      </Form.Item>
    </Col>
    <Col xs={24} md={18}>
      <Form.Item name="cus_name" label="ชื่อ-นามสกุล / ชื่อบริษัท" rules={[{ required: true, message: "กรอกชื่อลูกค้า" }]}>
        <Input maxLength={200} />
      </Form.Item>
    </Col>
    <Col xs={24} md={8}>
      <Form.Item name="tel" label="เบอร์โทร">
        <Input maxLength={50} />
      </Form.Item>
    </Col>
    <Col xs={24} md={8}>
      <Form.Item name="tel2" label="เบอร์สำรอง">
        <Input maxLength={50} />
      </Form.Item>
    </Col>
    <Col xs={24} md={8}>
      <Form.Item name="line_id" label="LINE ID">
        <Input maxLength={100} />
      </Form.Item>
    </Col>
    <Col xs={24} md={12}>
      <Form.Item name="email" label="อีเมล" rules={[{ type: "email", message: "รูปแบบอีเมลไม่ถูกต้อง" }]}>
        <Input maxLength={100} />
      </Form.Item>
    </Col>
    <Col xs={24} md={12}>
      <Form.Item name="source" label="รู้จักเราจาก">
        <Select allowClear options={SOURCE_OPTIONS} />
      </Form.Item>
    </Col>
    <Col span={24}>
      <Typography.Text strong>ที่อยู่ติดต่อ</Typography.Text>
    </Col>
    <Col span={24}>
      <Form.Item name="address" label="บ้านเลขที่ / ถนน">
        <Input maxLength={255} />
      </Form.Item>
    </Col>
    <Col xs={24} md={6}>
      <Form.Item name="subdistrict" label="ตำบล/แขวง">
        <Input maxLength={100} />
      </Form.Item>
    </Col>
    <Col xs={24} md={6}>
      <Form.Item name="district" label="อำเภอ/เขต">
        <Input maxLength={100} />
      </Form.Item>
    </Col>
    <Col xs={24} md={6}>
      <Form.Item name="province" label="จังหวัด">
        <Select allowClear showSearch options={PROVINCE_OPTIONS} />
      </Form.Item>
    </Col>
    <Col xs={24} md={6}>
      <Form.Item name="zipcode" label="รหัสไปรษณีย์">
        <Input maxLength={10} />
      </Form.Item>
    </Col>
    <Col span={24}>
      <Form.Item name="remark" label="หมายเหตุ">
        <Input.TextArea rows={2} maxLength={2000} />
      </Form.Item>
    </Col>
  </Row>
);

export default function CustomerPage() {
  const [portalOf, setPortalOf] = useState(null);
  const [reloadKey, setReloadKey] = useState(0);
  return (
    <>
    <CrudPage
      reloadKey={reloadKey}
      title="ข้อมูลลูกค้า"
      subtitle="ลูกค้าที่ติดต่อสร้างบ้าน — ใช้ตอนเปิดโปรเจ็กต์บ้าน"
      menu="support_customer"
      rowKey="cus_code"
      service={CustomerService}
      addText="เพิ่มลูกค้า"
      initialValues={{ prename: "คุณ", province: "ระยอง" }}
      renderForm={(form, editing) => (
        <>
          <CustomerFormFields />
          {editing && (
            <Form.Item name="active_status" label="สถานะ">
              <Select options={[{ value: "Y", label: "ใช้งาน" }, { value: "N", label: "ปิดใช้งาน" }]} />
            </Form.Item>
          )}
        </>
      )}
      columns={() => [
        { title: "รหัส", dataIndex: "cus_code", width: 120 },
        { title: "ชื่อลูกค้า", key: "name", render: (_, r) => [r.prename, r.cus_name].filter(Boolean).join(" ") },
        { title: "เบอร์โทร", dataIndex: "tel" },
        { title: "LINE", dataIndex: "line_id" },
        { title: "จังหวัด", dataIndex: "province" },
        { title: "รู้จักจาก", dataIndex: "source" },
        { title: "โปรเจ็กต์", dataIndex: "project_count", align: "center", width: 90 },
        {
          title: "Login ลูกค้า",
          key: "portal",
          width: 150,
          render: (_, r) => (
            <Tooltip title={r.portal_username ? `ชื่อผู้ใช้ ${r.portal_username}` : "ยังไม่มี login เข้า /portal"}>
              <Button
                size="small"
                icon={<KeyOutlined />}
                className={r.portal_active === "Y" ? "ak-btn-portal-on" : undefined}
                onClick={() => setPortalOf(r)}
              >
                {r.portal_active === "Y" ? "ใช้งานอยู่" : r.portal_username ? "ปิดอยู่" : "สร้าง login"}
              </Button>
            </Tooltip>
          ),
        },
        { title: "สถานะ", dataIndex: "active_status", width: 100, render: (v) => <StatusTag value={v} /> },
      ]}
    />
    <PortalLoginModal
      open={!!portalOf}
      customer={portalOf}
      onClose={() => setPortalOf(null)}
      onChanged={() => setReloadKey((k) => k + 1)}
    />
    </>
  );
}
